import { Injectable } from '@angular/core';
import { FlamingoAuthService } from '@flamingo/service/flamingo-auth.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseNavigation } from '@fuse/types';
import { MainService } from '../children/main/main.service';
import { getNavigation } from './main.navigation';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {

  profileNavigation: FuseNavigation = {
    id: 'profile',
    title: 'Profilo',
    translate: 'NAV.PROFILE',
    type: 'group',
    children: [
      {
        id: 'home',
        title: 'Home',
        type: 'item',
        icon: 'home',
        url: '/pending',
      },
      {
        id: 'profile',
        title: 'Profilo',
        translate: 'NAV.PROFILE',
        type: 'item',
        icon: 'person',
        url: '/profile',
      },
    ],
  };

  constructor(
    private _authService: FlamingoAuthService,
    private _fuseNavigationService: FuseNavigationService,
    private _mainService: MainService,
  ) {
  }

  setNavigation(showNavigation?: boolean): void {
    this._fuseNavigationService.unregister('main');
    this._fuseNavigationService.register(
      'main',
      showNavigation ? getNavigation(this._authService, this._mainService) : [this.profileNavigation],
    );
    this._fuseNavigationService.setCurrentNavigation('main');
  }
}
